import AppleAndBooksIcon from './component.jsx'
export default AppleAndBooksIcon
